/**
 * Shared TanStack QueryClient singleton.
 *
 * Lives in its own module so non-React code (data-source mutations,
 * fire-and-forget invalidations) can reach into the cache without
 * needing a hook. main.tsx imports this and passes it to the
 * QueryClientProvider; any other module that needs cache access
 * imports it directly.
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});
